export default {
    name: 'modal',
    store() {
        return {
            open: false,
            wasOpened: 0,

            init() {
                const stored = localStorage.getItem('modalWasOpened');
                const timestamp = localStorage.getItem('modalTimestamp');

                if (stored && timestamp) {
                    const age = Date.now() - Number(timestamp);
                    const THIRTY_MINUTES = 30 * 60 * 1000;

                    if (age > THIRTY_MINUTES) {
                        localStorage.removeItem('modalWasOpened');
                        localStorage.removeItem('modalTimestamp');
                        this.wasOpened = 0;
                    } else {
                        this.wasOpened = Number(stored);
                    }
                }
            },

            openModalOnce() {
                if (this.wasOpened < 1) {
                    this.open = true;
                    this.wasOpened = 1;
                    localStorage.setItem('modalWasOpened', '1');
                    localStorage.setItem('modalTimestamp', Date.now().toString());
                }
            },

            closeModal() {
                this.open = false;
            }
        };
    }
};
